import React from 'react';
import { QueryCache, MutationCache, QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { removeOldestQuery } from '@tanstack/react-query-persist-client';
import { SESSION_EXPIRED_MESSAGE } from 'constants/apiErrorMessages';
import { isSessionErrorMessage } from 'helpers/authenticationErrors';
import {
  clearSessionAuthError,
  getSessionAuthErrorMessage,
  notifySessionExpired,
} from 'helpers/sessionExpiredNotifier';

const HOUR = 60 * 60 * 1000;

const logger = (error) => console.error('error', error);

const handleQueryAuthError = (error) => {
  logger(error);

  const message = error?.message;
  if (typeof message === 'string' && isSessionErrorMessage(message)) {
    notifySessionExpired(SESSION_EXPIRED_MESSAGE);
  }
};

const clearSessionAuthErrorAfterSuccessfulQuery = () => {
  if (getSessionAuthErrorMessage()) {
    clearSessionAuthError();
  }
};

export const queryClient = new QueryClient({
  defaultOptions: { queries: { cacheTime: 12 * HOUR, retry: 1 } },
  queryCache: new QueryCache({
    onError: handleQueryAuthError,
    onSuccess: clearSessionAuthErrorAfterSuccessfulQuery,
  }),
  mutationCache: new MutationCache({
    onError: handleQueryAuthError,
    onSuccess: clearSessionAuthErrorAfterSuccessfulQuery,
  }),
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  retry: removeOldestQuery,
});

const QueryProvider = ({ children }) => (
  <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
    {children}
  </PersistQueryClientProvider>
);

export default QueryProvider;
